import { gql } from "apollo-boost";


export const GET_PRINTERS = gql`
query Printers($where: PrinterWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  printers(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    data {
      name
      ip
      id
      status
      type
      width
    }
    total
  }
}
`